import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus, faUser } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import OutsideClick from '../../common/OutsideClick';
import useSearchStore from '../../../store/hotel/search';

export default function GuestRoomSelection() {
  const [guestsShow, setGuestsShow] = useState(false);
  const { setParams, rooms, adults, children } = useSearchStore((state) => ({
    setParams: state.setParams,
    children: state.children,
    rooms: state.rooms,
    adults: state.adults,
  }));
  const setRoomDecrease = () => {
    if (rooms > 1) {
      setParams({ rooms: +rooms - 1 });
    }
  };

  const setRoomIncrease = () => {
    if (rooms < 4) {
      setParams({ rooms: +rooms + 1 });
    }
  };
  const setAdultDecrease = () => {
    if (adults > 1) {
      setParams({ adults: +adults - 1 });
    }
  };

  const setAdultIncrease = () => {
    if (adults < 9) {
      setParams({ adults: +adults + 1 });
    }
  };

  return (
    <div className="rs_form_row rs_rooms_row rs_gues_row rs_1365_33">
      <FontAwesomeIcon icon={faUser} className="fa-location-icon" />
      <div className="gues rs_chk_in" onClick={() => setGuestsShow(true)}>
        <div className="rs_chk_in room border-0 bg-transparent w-100">
          <p className={rooms ? 'check_titles check_title' : 'check_title'}>Guests</p>
          <p className={rooms ? 'check_contents check_content' : 'check_content'} style={{ display: rooms ? 'block' : 'none' }}>
            {rooms} {rooms <= 1 ? 'room' : 'rooms'}, {+adults + +children} {+adults + +children <= 1 ? 'guest' : 'guests'}
          </p>
        </div>
      </div>
      <OutsideClick click={setGuestsShow} listener={guestsShow}>
        <div className="rs_initial_hide rs_order pb-5" style={{ display: guestsShow ? 'block' : 'none' }}>
          <ul>
            <li>
              <span className="title">Rooms</span>
              <div>
                <Button
                  className="rounded-circle btn-outline-select"
                  size="sm"
                  variant="outline-primary"
                  onClick={() => {
                    setRoomDecrease();
                  }}
                >
                  <FontAwesomeIcon icon={faMinus} />
                </Button>
                <span className="nums text-dark">{rooms}</span>
                <Button
                  className="rounded-circle btn-outline-select"
                  size="sm"
                  variant="outline-primary"
                  onClick={() => {
                    setRoomIncrease();
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
            </li>
            <li>
              <span className="title">Adults</span>
              <div>
                <Button className="rounded-circle btn-outline-select" size="sm" variant="outline-primary" onClick={() => setAdultDecrease()}>
                  <FontAwesomeIcon icon={faMinus} />
                </Button>
                <span className="nums text-dark">{adults}</span>
                <Button className="rounded-circle btn-outline-select" size="sm" variant="outline-primary" onClick={() => setAdultIncrease()}>
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
            </li>
          </ul>
        </div>
      </OutsideClick>
    </div>
  );
}
